import { inject, Injectable } from '@angular/core';
import { APIProviderService } from '../api/api.provider.service';
import { assert } from 'src/app/utils/assert.util';
import { WebProviderService } from '../web/web.provider.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TimeProviderService {
  protected webProvider = inject(WebProviderService);
  protected get url(): string {
    return `${environment.apiURL}/api/Time`;
  }

   async get(): Promise<string> {
      const dateString = await this.webProvider.get<string>(this.url, { responseType: 'text' });
      assert(dateString, 'Date response was null');
      return dateString;
    }
}
